import React from 'react'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { VouchersApi } from '../../../../api/Purchase/Vouchers'
import { get, isEmpty } from 'lodash'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Link } from 'react-router-dom'
import DateCell from '../../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../../elements/Table/Cells/StatusCell'
import { statusFilterMethod } from '../../../../components/Purchasing/Voucher/TableComponents/StatusFilter'
import StatusFilter from '../../../../components/Sales/Orders/TableComponents/StatusFilter'
import IssuedStatusCell from '../../../../elements/Table/Cells/IssuedStatusCell'

Remittances.propTypes = {}
Remittances.defaultPropTypes = {
  voucher: {},
}
const columns = [
  {
    Header: 'Code',
    accessor: 'remittance.code',
    Cell: ({ value, original }) => (
      <Link
        target={'_blank'}
        to={{
          pathname: `/purchasing/remittance/${original.remittance._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },

  { Header: 'Date', accessor: 'remittance.date', Cell: DateCell },
  { Header: 'Payee Name', accessor: 'remittance.to.payee.fn' },
  {
    Header: 'Payee Bank ',
    accessor: 'remittance.to.bank.accname',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Company',
    accessor: 'remittance.company.fn',
    hideDefault: true,
    hideable: true,
  },

  {
    Header: 'Bank ',
    accessor: 'remittance.from.bank.accname',
    hideDefault: true,
    hideable: true,
  },
  { Header: 'Currency', accessor: 'voucher.currency' },
  {
    Header: 'Voucher Allocation',
    accessor: 'allocation',
    Cell: MoneyCell,
  },
  {
    Header: 'Full Remittance Amount',
    accessor: 'remittance.from.amount',
    Cell: ({ value, original }) => <MoneyCell value={value} currency={get(original, 'remittance.from.currency')} />,
  },
  {
    Header: 'Status',
    accessor: 'remittance.status',
    Cell: StatusCell,
    filterMethod: statusFilterMethod,
    Filter: StatusFilter,
  },
  {
    Header: 'Issuance Status',
    accessor: 'remittance.issuance.issued',
    Cell: IssuedStatusCell,
  },
]

function Remittances(props) {
  const { voucher } = props
  const { fetch, fetching, list } = useFetchList(
    () => VouchersApi.remittances(voucher._key),
    [voucher._key],
    isEmpty(voucher._key)
  )

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
    />
  )
}

export default Remittances
